import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    this.onClickOutside = this.onClickOutside.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    this.close();
  }

  toggle(event) {
    event.stopPropagation();
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.hasMenuTarget) return;

    this.menuTarget.classList.remove("hidden");
    // Force reflow so enter transition runs
    void this.menuTarget.offsetWidth;
    this.menuTarget.classList.add("ui-menu--open");
    this.menuTarget.setAttribute("data-open", "true");

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true");
      this.buttonTarget.classList.add("ui-trigger--open");
    }

    document.addEventListener("click", this.onClickOutside);
    document.addEventListener("keydown", this.onKeydown);
  }

  close() {
    if (!this.hasMenuTarget) return;

    this.menuTarget.classList.remove("ui-menu--open");
    this.menuTarget.removeAttribute("data-open");
    this.menuTarget.classList.add("hidden");

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false");
      this.buttonTarget.classList.remove("ui-trigger--open");
    }

    document.removeEventListener("click", this.onClickOutside);
    document.removeEventListener("keydown", this.onKeydown);
  }

  isOpen() {
    return this.hasMenuTarget && !this.menuTarget.classList.contains("hidden");
  }

  onClickOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      this.close();
      if (this.hasButtonTarget) this.buttonTarget.focus();
    }
  }
}
